import { useLastRanAtFriendly } from "src/pages/analytics/utils/last-ran-at-friendly";
import { Text, Tooltip } from "@hightouch/htui";
import { useChartDataContext } from "src/pages/analytics/state";

export const LastRefreshedAtLabel = ({
  hidePrefix = false,
}: {
  hidePrefix?: boolean;
}) => {
  const { isPolling, lastRanAt } = useChartDataContext();
  const lastRanAtFriendly = useLastRanAtFriendly({
    runAt: lastRanAt,
    hidePrefix,
  });

  return (
    <Tooltip
      message={
        lastRanAt ? new Date(lastRanAt).toLocaleString() : "Never refreshed"
      }
    >
      <Text size="sm" color="text.secondary">
        {isPolling ? "Refreshing…" : lastRanAtFriendly}
      </Text>
    </Tooltip>
  );
};
